
const PainPointsSection = () => {
  const painPoints = [
    {
      title: "Start things, never finish them",
      description: "You download apps with big plans, use them for 3 days, then forget they exist.",
      emoji: "😫"
    },
    {
      title: "Make commitments, break them immediately",
      description: "Forever habits feel overwhelming. One missed day and you're back to square one.",
      emoji: "💔"
    },
    {
      title: "Feel like a failure with every habit app",
      description: "Complex tracking, perfect streaks, shame spirals. Sound familiar?",
      emoji: "😤"
    }
  ];

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Background Elements with subtle bubbles */}
      <div className="absolute inset-0">
        <div className="absolute top-10 right-10 w-32 h-32 bg-purple-100 rounded-full blur-3xl animate-pulse-gentle"></div>
        <div className="absolute bottom-10 left-10 w-40 h-40 bg-yellow-100 rounded-full blur-3xl animate-pulse-gentle delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-purple-50 rounded-full blur-3xl"></div>
      </div>

      <div className="container max-w-6xl mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6 tracking-tight">
            Tired of overcomplicating
            <span className="block text-purple-600">everything?</span>
          </h2>
          <p className="text-2xl text-gray-700 font-bold max-w-3xl mx-auto leading-relaxed">
            We get it. Life is messy, and most apps make it worse.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {painPoints.map((point, index) => (
            <div key={index} className="text-center group">
              <div className="mb-6 flex justify-center">
                <div className="w-24 h-24 flex items-center justify-center bg-purple-50 rounded-2xl group-hover:bg-purple-100 transition-colors duration-300 shadow-lg">
                  <span className="text-5xl">{point.emoji}</span>
                </div>
              </div>
              <h3 className="text-2xl font-black text-gray-900 mb-4">
                {point.title}
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed font-medium">
                {point.description}
              </p>
            </div>
          ))}
        </div>

        {/* Transition */}
        <div className="text-center bg-gradient-to-r from-purple-100 to-purple-50 rounded-3xl p-12 relative overflow-hidden">
          {/* Subtle bubble effect */}
          <div className="absolute top-4 right-4 w-16 h-16 bg-purple-200/50 rounded-full blur-xl"></div>
          <div className="absolute bottom-4 left-4 w-20 h-20 bg-yellow-200/50 rounded-full blur-xl"></div>
          
          <div className="relative z-10">
            <h3 className="text-3xl md:text-4xl font-black text-purple-900 mb-4">
              Show Up! is different.
            </h3>
            <p className="text-xl text-purple-700 font-bold">
              We focus on experiments, not perfection.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PainPointsSection;
